import { makeStyles, webLightTheme } from '@fluentui/react-components';
import * as React from 'react';
import { defineMessages, useIntl } from 'react-intl';
import WindowsAppIcon_LightMode from '../../../content/images/windows-app-icon_black.svg';
import WindowsAppIcon_DarkMode from '../../../content/images/windows-app-icon_white.svg';
import { useCurrentFluent2Theme } from '../../../hooks/styling';

interface ProductImageProps {}

const messages = defineMessages({
    imageAlt: {
        id: 'WindowsApp_Image_Alt',
        defaultMessage: 'Windows App',
        description: 'Alt text for windows app icon',
    },
});

/**
 * Styles
 */

const useStyles = makeStyles({
    root: {
        height: '20px',
        width: '20px',
    },
});

/**
 * END Styles
 */

export const WindowsAppIcon: React.FC<ProductImageProps> = React.memo(() => {
    // Intl hooks
    const { formatMessage } = useIntl();
    const theme = useCurrentFluent2Theme();

    // Style hooks
    const styles = useStyles();

    const icon = theme === webLightTheme ? WindowsAppIcon_LightMode : WindowsAppIcon_DarkMode;

    return <img alt={formatMessage(messages.imageAlt)} className={styles.root} src={icon} />;
});

export default WindowsAppIcon;
